import React, { useContext, useEffect } from 'react';
import { Players } from '../Players';
import { AppContext } from '../../common/contexts/AppContext';

export function VenueExplorer(props) {

  const { appData, appContextStateHandler } = useContext(AppContext)

  useEffect(() => {
    appContextStateHandler({ pageKey: 'VenueExplorer' })
  }, [])

  return (
    <Players venueExplorer={true} />
  )

}


// WEBPACK FOOTER //
// ./src/screens/admin/VenuesExplorer.js